export enum Routes {
    Home = '/',
    SignIn = '/sign_in',
    GoogleAuth = '/auth/google_oauth2',
    SignUp = '/sign_up',
    SignOut = '/sign_out',
    User = '/user',
    Orders = '/orders',
    Blog = '/blog',
    Changelog = '/changelog',
    Sellers = '/sellers',
    Checkout = '/checkout',
    ProfileOrders = '/profile/orders',
    Purchases = '/profile/purchases',
    Reviews = '/profile/reviews',
    Wishlist = '/profile/wishlist',
    WishlistItems = '/profile/wishlist/items',
    WishlistCollections = '/profile/wishlist/collections',
    Offers = '/profile/offers',
    BulkCreateOffers = '/profile/offers/bulk_create',
    ImportPreviewOffers = '/profile/offers/import_preview',
    SaveOfferDrafts = '/profile/offers/save_drafts',
    AutoPriceOffer = '/profile/offers/auto_price',
    OffersAnalytics = '/profile/offers/analytics',
    NewOffer = '/profile/offers/new',
    Sales = '/profile/sales',
    ProfileEdit = '/profile/edit',
    ProfileAccount = '/profile/account',
    Balance = '/profile/balance',
    BalanceDeposits = '/profile/balance/deposits',
    CompleteGoogleOauthProfile = '/auth/google_oauth2/complete_profile',
    ProductProposals = '/profile/product_proposals',
    UserConfirmation = '/users/confirmation',
    Search = '/search',
    ProductLookup = '/search/products',
    ActiveSearch = '/search/active',
    Terms = '/terms',
    Privacy = '/privacy',
    ForgotPassword = '/password/new',
    ResetPassword = '/password/edit',
    Password = '/password',
    ProfileDelivery = '/profile/delivery',
    ProfileAvailability = '/profile/availability',
    ProfileNotificationSettings = '/profile/notification_settings',
    ApiNovaPoshtaCities = '/api/nova_poshta/cities',
    ApiNovaPoshtaWarehouses = '/api/nova_poshta/warehouses',
    ApiUkrposhtaSettlements = '/api/ukrposhta/settlements',
    ApiUkrposhtaOffices = '/api/ukrposhta/offices',
    OfferViews = '/offer_views',
}

export const profileDeliveryRoute = (method: 'nova_poshta' | 'ukrposhta') =>
    `${Routes.ProfileDelivery}/${method}`;

export const profileAvailabilityRoute = () => Routes.ProfileAvailability;

export const profileNotificationSettingsRoute = () =>
    Routes.ProfileNotificationSettings;

export const premiumOffersRoute = (universeSlug: string) =>
    `/${universeSlug}/premium`;

export const profileOrderRoute = (orderId: number | string) =>
    `${Routes.ProfileOrders}/${orderId}`;

export const profileOrderRevisionRoute = (orderId: number | string) =>
    `${profileOrderRoute(orderId)}/revision`;

export const profileOrderEditOffersRoute = (orderId: number | string) =>
    `${profileOrderRoute(orderId)}/edit_offers`;

export const profileOrderBuyerUpdateRoute = (orderId: number | string) =>
    `${profileOrderRoute(orderId)}/update_by_buyer`;

export const profileOrderRevisionActionRoute = (
    orderId: number | string,
    action: 'accept' | 'reject',
) => `${profileOrderRevisionRoute(orderId)}/${action}`;

export const profileOfferRoute = (offerId: number | string) =>
    `${Routes.Offers}/${offerId}`;

export const profileOfferAmountRoute = (offerId: number | string) =>
    `${profileOfferRoute(offerId)}/update_amount`;

export const profileOfferActivatePremiumRoute = (offerId: number | string) =>
    `${profileOfferRoute(offerId)}/activate_premium`;

export const offerViewsRoute = () => Routes.OfferViews;

export const wishlistItemRoute = (productId: number | string) =>
    `${Routes.WishlistItems}/${productId}`;

export const wishlistItemCollectionsRoute = (productId: number | string) =>
    `${wishlistItemRoute(productId)}/collections`;

export const wishlistCollectionRoute = (collectionId: number | string) =>
    `${Routes.WishlistCollections}/${collectionId}`;

export const profileOffersPremiumRoute = () => `${Routes.Offers}?premium=open`;

export const profilePremiumPackageCheckoutRoute = (
    serviceId: number | string,
) => `${Routes.Offers}/premium_packages/${serviceId}/create_checkout`;

export const profileOrderActionRoute = (
    orderId: number | string,
    action:
        | 'confirm_order'
        | 'add_tracking'
        | 'hand_over'
        | 'confirm_received'
        | 'review'
        | 'reject'
        | 'cancel',
) => `${profileOrderRoute(orderId)}/${action}`;

export const userReviewsRoute = (nickname: string) =>
    `${Routes.User}/${nickname}/reviews`;
